// src/features/departments/Routes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import DepartmentsPage from './pages/DepartmentsPage';
import ModulesPage from './pages/ModulesPage';
import CreateDepartmentPage from './pages/CreateDepartmentPage';
import EditDepartmentPage from './pages/EditDepartmentPage';

export const DepartmentRoutes = () => (
  <>
    <Route
      path="departments"
      element={
        <ProtectedRoute requiredScope="admin-department:read">
          <DepartmentsPage />
        </ProtectedRoute>
      }
    />
    <Route 
      path="/departments/create" 
      element={
        <ProtectedRoute requiredScope="admin-department:create">
          <CreateDepartmentPage />
        </ProtectedRoute>
      } 
    />
    <Route 
      path="/departments/:departmentId/edit" 
      element={
        <ProtectedRoute requiredScope="admin-department:update">
          <EditDepartmentPage />
        </ProtectedRoute>
      } 
    />
    <Route
      path="modules"
      element={
        <ProtectedRoute requiredScope="admin-module:read">
          <ModulesPage />
        </ProtectedRoute>
      }
    />
  </>
);